export default __webpack_public_path__ + "static/media/LTPCT-Banner.cc1f0571.png";